import { BaseClusterRenderer, MarkerTypeConfig } from "../../../_shared/interfaces/maps/base-cluster-renderer";

export class FuelLevelClusterRenderer extends BaseClusterRenderer {
  protected override getMarkerTypesConfig(): { [key: string]: MarkerTypeConfig; } {
    return {
      'normal': { color: '#ee2737' },
      'warning': { color: '#FF7F00', pulsate: true }
    }
  }

  protected override getMarkerType(marker: google.maps.marker.AdvancedMarkerElement): string | null {
    const markerContentElement = marker.content as HTMLElement | null;
    return markerContentElement?.dataset?.['type']!;
  }
}